/** @format */

import APIRequest from '../utils/APIRequest';

export default class User {
  static getCurrency = async (email, password) => {
    let response = await fetch(
      `https://v6.exchangerate-api.com/v6/${process.env.REACT_APP_EXCHANGERATEAPI}/latest/IDR`
    );
    let data = await response.json();
    return data;
  };

  static login = async (email, password) => {
    return await APIRequest.set('v1/user/login', 'POST', {
      email: email,
      password: password,
    });
  };
  static register = async (body) => {
    return await APIRequest.set('v1/user/register', 'POST', body);
  };

  static connectWFB = async (body) => {
    return await APIRequest.set(
      'v1/waba/generate/generate_oauth',
      'POST',
      body
    );
  };

  static create = async (body) => {
    return await APIRequest.set('v1/user', 'POST', body);
  };
  static getAll = async () => {
    return await APIRequest.set('v1/users', 'GET');
  };
  static getByID = async (id) => {
    return await APIRequest.set(`v1/user/${id}/complete`, 'GET');
  };
  static update = async (id, body) => {
    return await APIRequest.set(`v1/user/${id}`, 'PUT', body);
  };

  static getByEmailAndToken = async (email, token) => {
    return await APIRequest.set(
      `v1/user/getbytoken?email=${encodeURIComponent(email)}&token=${token}`,
      'GET'
    );
  };

  static claimToken = async (email, token, password) => {
    // console.log("CPARAM", { email, token });
    return await APIRequest.set(`v1/user/claim/${token}`, 'POST', {
      email,
      password,
    });
  };

  static getSelf = async () => {
    return await APIRequest.set('v1/user/self', 'GET');
  };
  static updateSelf = async (body) => {
    return await APIRequest.set('v1/user/self', 'PUT', body);
  };
  static updateSelfPassword = async (body) => {
    return await APIRequest.set('v1/user/self', 'POST', body);
  };

  // TOTP Methods
  static loginWithTOTP = async (email, password, totpToken) => {
    return await APIRequest.set('v1/user/login-totp', 'POST', {
      email,
      password,
      totpToken,
    });
  };

  static setupTOTP = async () => {
    return await APIRequest.set('v1/user/totp/setup', 'POST');
  };

  static verifyTOTP = async (token) => {
    return await APIRequest.set('v1/user/totp/verify', 'POST', { token });
  };

  static getTOTPStatus = async () => {
    return await APIRequest.set('v1/user/totp/status', 'GET');
  };

  static disableTOTP = async (token) => {
    return await APIRequest.set('v1/user/totp/disable', 'POST', { token });
  };
}
